<div class="button-placement-right" style="align-items: center">
  <ul class="dropdown menu" data-dropdown-menu>
    <li>
      <a class="a-link-no-underline" style="display: flex; align-items: center">
        <fa-icon [icon]="'user-circle'" style="align-self: center; margin-right: 8px"></fa-icon>
        <div style="display: flex; flex-direction: column">
         <span>{{user.firstName}}&nbsp;{{user.lastName}} ({{user.loginName}})</span>
          <span>{{user.email}}</span>
        </div>
      </a>
      <ul class="menu">
        <li><a (click)="navigateToUserSettings()">Settings</a></li>
        <li><a (click)="logout()">Logout</a></li>
      </ul>
    </li>
  </ul>
</div>
